const translation = {
    PageSize: 'Sivukoko',
    PageOrientation: 'Sivun suunta',
    Format: 'Muoto',
    DPI: 'DPI',
    Title: 'Vie kartta',
    Close: 'Sulje',
    Save: 'Tallenna',
    FileName: 'Tiedostonimi',
    Landscape: 'Vaaka',
    Portrait: 'Pysty',
    PreviewHint: 'Säädä vietävää aluetta kartalla.',
    ExportFailed: 'Kartan vienti epäonnistui. Yritä uudelleen.',
    PreviewFailed: 'Esikatselun luominen epäonnistui.',
    AdjustArea: 'Säädä aluetta kartalla',
    AdjustAreaHint: 'Siirrä, zoomaa, kierrä tai kallista karttaa rajataksesi vietävän alueen',
    ZoomIn: 'Lähennä',
    ZoomOut: 'Loitonna',
    ResetZoom: 'Palauta zoomaus 100 %:iin',
    Done: 'Valmis',
    Cancel: 'Peruuta',
    Scalebar: 'Mittakaava',
    NorthIcon: 'Pohjoisnuoli',
    ChooseNorthIcon: 'Valitse pohjoisnuoli',
    ChooseSvgFile: 'Valitse SVG-tiedosto',
    IconSymbol: 'Symboli',
    IconColor: 'Väri',
    IconSize: 'Koko',
    InvalidSvg: 'Tiedosto ei ole kelvollinen SVG.',
    ExportAsVector: 'Vie vektorina',
    ExportLabelsAsVector: 'Vie nimiöt vektorina',
    Custom: 'Mukautettu',
    Width: 'Leveys',
    Height: 'Korkeus',
    LanguageName: 'Suomalainen',
    LanguageCode: 'fi'
};
export default translation;
